export { ReactComponent as VerticalObject } from './svgs/vertical-object.svg';
